import { Message } from '@/types/widgets/messagesWidget/messagesWidget';

export const messagesBoardDemoData: Message[] = [
  {
    body: '<p>Hi,</p>\n<p>We have sent the rent for January via the app today.</p>\n<p>If you have already paid your rent in another way, you can disregard this notification.</p>\n<p>Best regards,</p>\n<p>Primula Byggnads AB</p>\n<p></p>\n',
    created: '2024-12-17T12:55:31.014Z',
    externalId: 'sandhamnsgatan42',
    title: 'Rent Notification via the App',
    updated: '2024-12-17T12:55:52.851Z',
  },
  {
    body: '<p>Hi,</p>\n<p>This is a reminder that your February rent is now available in the app.</p>\n<p>Please make the payment by the 28th to avoid any late fees.</p>\n<p>Best regards,</p>\n<p>Primula Byggnads AB</p>\n<p></p>\n',
    created: '2025-01-25T09:10:12.451Z',
    externalId: 'sandhamnsgatan42',
    title: 'February Rent Reminder',
    updated: '2025-01-25T09:10:12.451Z',
  },
  {
    body: '<p>Hello,</p>\n<p>We wanted to inform you that maintenance work will take place in the stairwell on March 5th between 08:00–12:00.</p>\n<p>Please keep the area clear during this time.</p>\n<p>Sincerely,</p>\n<p>Primula Byggnads AB</p>\n',
    created: '2025-02-28T14:23:05.712Z',
    externalId: 'sandhamnsgatan42',
    title: 'Scheduled Maintenance Notification',
    updated: '2025-02-28T14:23:05.712Z',
  },
  {
    body: '<p>Hi,</p>\n<p>The rent for April is now sent via the app. You can view and pay it directly there.</p>\n<p>Contact us if you have any questions.</p>\n<p>Best regards,</p>\n<p>Primula Byggnads AB</p>\n',
    created: '2025-03-27T11:44:19.103Z',
    externalId: 'sandhamnsgatan42',
    title: 'April Rent Available',
    updated: '2025-03-27T11:44:19.103Z',
  },
  {
    body: '<p>Hello,</p>\n<p>Spring cleaning of the courtyard will be carried out on May 15th. Please remove any personal items by then.</p>\n<p>Thank you for your cooperation.</p>\n<p>Regards,</p>\n<p>Primula Byggnads AB</p>\n',
    created: '2025-05-10T10:05:00.000Z',
    externalId: 'sandhamnsgatan42',
    title: 'Courtyard Cleaning Announcement',
    updated: '2025-05-10T10:05:00.000Z',
  },
];
